import { useControl } from "../hooks";
import type { BaseFormProps } from "../types";
import type { SelectProps } from "./Select";
import { Select } from "./Select";

export type FormSelectProps<T> = SelectProps &
	Omit<BaseFormProps, "error"> & {
		transform?: (value: string) => T;
	};

export const FormSelect = <T extends string | number>({ transform, hideError, ...props }: FormSelectProps<T>) => {
	const { error, field } = useControl({ name: props.name });
	return (
		<Select
			{...props}
			error={error}
			hideError={hideError}
			{...field}
			disabled={props.disabled}
			value={transform ? transform(field.value ?? "") : (field.value ?? "")}
			onChange={(e) => {
				field.onChange({
					...e,
					target: {
						...e.target,
						value: transform ? transform(e.target.value) : e.target.value,
					},
				});
				props.onChange?.(e);
			}}
		/>
	);
};
